module.exports = __webpack_public_path__ + "static/media/icomanual_instalacion_gris.5f5d952d.svg";